import produce from "immer";
import { IStoreState } from "../../initialStoreState";
import { LoadState } from "../../../constants/enums";
import { LifeInsurancePolicyBasicAction } from ".";
import { initialLifeInsuranceBasicDetails } from "./lifeInsuranceBasicDetail.types";
import {
  ADD_LIFE_INSURANCE_CLAIM,
  ADD_LIFE_INSURANCE_CUSTOMER_INFO,
  ADD_LIFE_INSURANCE_POLICY_ADMIN,
  ADD_LIFE_INSURANCE_PREMIUM,
  CLAER_LIFE_INSURANCE_POLICY_ATTACHMENT_STATE,
  CLEAR_LIFE_INSURANCE_BASIC_DETAILS_STATE,
  FETCH_LIFE_INSURANCE_ATTACHMENT_FAILED,
  FETCH_LIFE_INSURANCE_ATTACHMENT_LIST_FAILED,
  FETCH_LIFE_INSURANCE_ATTACHMENT_LIST_PROGRESS,
  FETCH_LIFE_INSURANCE_ATTACHMENT_LIST_SUCCESS,
  FETCH_LIFE_INSURANCE_ATTACHMENT_PROGRESS,
  FETCH_LIFE_INSURANCE_ATTACHMENT_SUCCESS,
  FETCH_LIFE_INSURANCE_CLAIM_FAILED,
  FETCH_LIFE_INSURANCE_CLAIM_PROGRESS,
  FETCH_LIFE_INSURANCE_CUSTOMER_INFO_FAILED,
  FETCH_LIFE_INSURANCE_CUSTOMER_INFO_PROGRESS,
  FETCH_LIFE_INSURANCE_POLICY_ADMIN_FAILED,
  FETCH_LIFE_INSURANCE_POLICY_ADMIN_MANAGER_FAILED,
  FETCH_LIFE_INSURANCE_POLICY_ADMIN_MANAGER_PROGRESS,
  FETCH_LIFE_INSURANCE_POLICY_ADMIN_MANAGER_SUCCESS,
  FETCH_LIFE_INSURANCE_POLICY_ADMIN_PROGRESS,
  FETCH_LIFE_INSURANCE_PREMIUM_FAILED,
  FETCH_LIFE_INSURANCE_PREMIUM_PROGRESS,
} from "./lifeInsuranceBasicDetailActions";

export const lifeInsuranceBasicDetailsReducer = (
  state: IStoreState["lifeInsurance"]["basicDetails"] = initialLifeInsuranceBasicDetails,
  action: LifeInsurancePolicyBasicAction
) => {
  switch (action.type) {
    case FETCH_LIFE_INSURANCE_CUSTOMER_INFO_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.customerInfo.Loading = LoadState.InProgress;
      });
      return newState;
    }
    case ADD_LIFE_INSURANCE_CUSTOMER_INFO: {
      const { customerInfo, customerPolicyId, isNewPolicy } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.customerInfo.Loading = LoadState.Loaded;
        draftState.customerInfo.data = customerInfo;
        draftState.customerPoliycId = customerPolicyId;
        draftState.isNewPolicy = isNewPolicy;
      });
      return newState;
    }
    case FETCH_LIFE_INSURANCE_CUSTOMER_INFO_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.customerInfo.Loading = LoadState.Failed;
        draftState.customerInfo.error = errorMessage;
      });
      return newState;
    }

    case FETCH_LIFE_INSURANCE_POLICY_ADMIN_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.policyAdmin.Loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_LIFE_INSURANCE_POLICY_ADMIN_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.policyAdmin.Loading = LoadState.Failed;
      });
      return newState;
    }
    case ADD_LIFE_INSURANCE_POLICY_ADMIN: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.policyAdmin.Loading = LoadState.Loaded;
        draftState.policyAdmin.data = data;
      });
      return newState;
    }

    case FETCH_LIFE_INSURANCE_POLICY_ADMIN_MANAGER_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.policyAdminManager.Loading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_LIFE_INSURANCE_POLICY_ADMIN_MANAGER_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.policyAdminManager.Loading = LoadState.Loaded;
        draftState.policyAdminManager.data = data;
      });
      return newState;
    }

    case FETCH_LIFE_INSURANCE_POLICY_ADMIN_MANAGER_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.policyAdminManager.Loading = LoadState.Failed;
      });
      return newState;
    }

    case FETCH_LIFE_INSURANCE_CLAIM_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.claim.Loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_LIFE_INSURANCE_CLAIM_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.claim.Loading = LoadState.Failed;
      });
      return newState;
    }
    case ADD_LIFE_INSURANCE_CLAIM: {
      const { claim } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.claim.Loading = LoadState.Loaded;
        draftState.claim.data = claim;
      });
      return newState;
    }

    case FETCH_LIFE_INSURANCE_PREMIUM_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.premium.Loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_LIFE_INSURANCE_PREMIUM_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.premium.Loading = LoadState.Failed;
      });
      return newState;
    }
    case ADD_LIFE_INSURANCE_PREMIUM: {
      const { premium } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.premium.Loading = LoadState.Loaded;
        draftState.premium.data = premium;
      });
      return newState;
    }

    case FETCH_LIFE_INSURANCE_ATTACHMENT_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.attachment.loading = LoadState.InProgress;
        draftState.attachment.data =
          initialLifeInsuranceBasicDetails["attachment"]["data"];
        draftState.attachment.error = null;
      });
      return newState;
    }
    case FETCH_LIFE_INSURANCE_ATTACHMENT_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.attachment.loading = LoadState.Loaded;
        draftState.attachment.data = data;
      });
      return newState;
    }
    case FETCH_LIFE_INSURANCE_ATTACHMENT_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.attachment.loading = LoadState.Failed;
        draftState.attachment.error = errorMessage;
      });
      return newState;
    }

    case FETCH_LIFE_INSURANCE_ATTACHMENT_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.attachment.listLoading = LoadState.InProgress;
        draftState.attachment.list = [];
      });
      return newState;
    }
    case FETCH_LIFE_INSURANCE_ATTACHMENT_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.attachment.listLoading = LoadState.Loaded;
        draftState.attachment.list = data;
      });
      return newState;
    }
    case FETCH_LIFE_INSURANCE_ATTACHMENT_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.attachment.listLoading = LoadState.Failed;
        draftState.attachment.list = [];
      });
      return newState;
    }

    case CLAER_LIFE_INSURANCE_POLICY_ATTACHMENT_STATE: {
      const newState = produce(state, (draftState) => {
        draftState.attachment = initialLifeInsuranceBasicDetails["attachment"];
      });
      return newState;
    }

    case CLEAR_LIFE_INSURANCE_BASIC_DETAILS_STATE: {
      return initialLifeInsuranceBasicDetails;
    }

    default: {
      return state;
    }
  }
};
